import { useQuery } from 'react-query';
import {
  getBulkRetargetingCampaignsQuery,
  GetBulkRetargetingCampaignsRequest,
} from './getBulkRetargetingCampaignsQuery';

export const useGetBulkRetargetingCampaignsQuery = (payload: GetBulkRetargetingCampaignsRequest) => {
  const query = useQuery(['bulk-retargeting-campaigns', payload.siteId], async () =>
    getBulkRetargetingCampaignsQuery(payload),
  );
  return query;
};
